import React from "react";
import Drawer from "../../components/ui/Drawer";
import { ViewRequestDocuments } from "../../components/requests/RequestViewDocuments";

export const ViewRequestDocDrawer = ({ title, onClose, data }) => {
  return (
    <>
      <Drawer title={title} onClose={onClose} width={550}>
        <ViewRequestDocuments data={data} title={title} onClose={onClose} />
      </Drawer>
    </>
  );
};
